import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '~environments/environment';

/**
 * Service for calling the API as well as storing modalOpened data
 */
@Injectable({
  providedIn: 'root'
})
export class DuplicateCheckService {
  public API_URL: any = environment.envAPI;
  public selectedCustomerId: number;

  constructor(private http: HttpClient) {
  }

  /**
   * Create a new address.
   */
  public getDuplicates(duplicateString: any, clubId: number): any {
    return this.http.get(`${this.API_URL}/clubs/${clubId}/customers/duplicate-check?${duplicateString}`);
  }

}
